var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"grab-control icon-drag-handler d-inline-block",on:{"mousedown":_vm.emitStart,"&touchstart":function($event){return _vm.emitStart($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }